module.exports = __webpack_public_path__ + "img/2-charles.92c37117.svg";